<script setup>
  import RadioControl from '@/components/RadioControl.vue';

  const model = defineModel();

  const options = {
    average: 'Average',
    gust: 'Gust'
  };
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'trigger-on-' + value" class="jwx-table-view__row-label">{{ label }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="model"
                name="trigger-on"
                :id="'trigger-on-' + value"
                :value="value"
                :srLabel="'Select ' + label"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
